import { render, staticRenderFns } from "./changeCardForm.vue?vue&type=template&id=446ce1a2&scoped=true&"
import script from "./changeCardForm.vue?vue&type=script&lang=js&"
export * from "./changeCardForm.vue?vue&type=script&lang=js&"
import style0 from "./changeCardForm.vue?vue&type=style&index=0&id=446ce1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446ce1a2",
  null
  
)

export default component.exports